import { useState, useEffect } from 'react';

interface CreditsData {
  balance: number;
  updatedAt: string | null;
}

// `enabled: false` desliga a busca e o polling — usado por quem não exibe saldo
// (ex.: SUPERADMIN na barra global, que ficaria repetindo a chamada a cada 60s
// para um número que nunca aparece na tela).
export function useCredits({ enabled = true }: { enabled?: boolean } = {}) {
  const [credits, setCredits] = useState<CreditsData | null>(null);
  const [loading, setLoading] = useState(enabled);

  const fetchCredits = async () => {
    try {
      const token = localStorage.getItem('auth_token');
      if (!token) {
        setLoading(false);
        return;
      }

      const headers: Record<string, string> = {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
      };
      const selectedTenantId = localStorage.getItem('superadmin_selected_tenant') || localStorage.getItem('selected_tenant_id');
      if (selectedTenantId) headers['X-Tenant-Id'] = selectedTenantId;
      const response = await fetch('/api/credits/my', {
        headers,
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setCredits(data.data);
        }
      }
    } catch (error) {
      console.error('Erro ao buscar créditos:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }
    fetchCredits();

    // Atualizar a cada 60 segundos
    const interval = setInterval(fetchCredits, 60000);
    return () => clearInterval(interval);
  }, [enabled]);

  return { credits, loading, refetch: fetchCredits };
}
